module.exports = __webpack_public_path__ + "images/cove.0e8be1285c33fdf06a2c57f2dd6adfe6.png";